import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";  // Boots i18next before any component renders
import App from "@/App";
import { registerServiceWorker } from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
